import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { BootstrapVueNext } from "bootstrap-vue-next";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import $ from "jquery";

// Global CSS
import "./assets/global.css"; // or app.css


// Import FontAwesome library and icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css"; // Replace 'swiper/swiper-bundle.min.css'
import { faFacebook, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'


// Import the i18n instance
import i18n from "./locales/i18n"; // Import the i18n instance from i18n.js

// PhotoGalery
import VueEasyLightbox from 'vue-easy-lightbox'

// TreeSelect
import TreeselectVue from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";

// Chart
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
// Import Bar Chart from vue-chartjs
import { Bar } from "vue-chartjs";

// Charts View
Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

// DatePicker
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";


// Calendar
import { Calendar, DatePicker } from "v-calendar";
import VCalendar from "v-calendar";
import "v-calendar/style.css";

import { getWebPagesId } from "./utils/webPage";

import { createHead } from '@vueuse/head'

import {
  faUser,
  faHome,
  faEnvelope,
  faBars,
  faSquare,
  faComments,
  faArrowRight,
  faScaleBalanced,
  faFileLines,
  faBriefcase,
  faVolumeHigh,
  faCircleNodes,
  faEarListen,
  faPhoneVolume,
  faLocationDot,
  faChevronRight,
  faDownload,
  faCircleDown,
  faChevronDown,
  faAngleRight,
  faAngleLeft,
  faFilePdf,
  faCircleInfo,
  faCircleLeft,
  faEye,
  faUserTie,
  faCirclePlay,
  faPlus,
  faMinus,
  faXmark
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faUser,
  faHome,
  faEnvelope,
  faBars,
  faSquare,
  faComments,
  faArrowRight,
  faScaleBalanced,
  faFileLines,
  faBriefcase,
  faVolumeHigh,
  faCircleNodes,
  faEarListen,
  faPhoneVolume,
  faLocationDot,
  faChevronRight,
  faDownload,
  faCircleDown,
  faChevronDown,
  faAngleRight,
  faAngleLeft,
  faFilePdf,
  faCircleInfo,
  faCircleLeft,
  faEye,
  faUserTie,
  faCirclePlay,
  faPlus,
  faMinus,
  faXmark,
  faFacebook,
  faYoutube,
  faLink
);

const pinia = createPinia();

if (process.env.NODE_ENV === "production") {
  console.log = function(){};
  console.warn = function(){};
  console.error = function(){};
}

const app = createApp(App);

app.provide("getWebPageId", getWebPagesId);

app.use(pinia);
app.use(router);
app.use(BootstrapVueNext);
app.config.globalProperties.$ = $;
app.config.globalProperties.$getWebPageId = getWebPagesId;
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("SwiperComponent", Swiper); // Changed name here
app.component("SwiperSlideComponent", SwiperSlide); // Changed name here
app.component("BarChart", Bar);
app.component("VCalendar", Calendar);
app.component("VDatePicker", DatePicker);
app.component("TreeselectVue", TreeselectVue);
app.component("VueDatePicker", VueDatePicker);
app.use(VueEasyLightbox);
app.use(i18n); // Use the imported i18n instance
app.use(createHead())
app.use(VCalendar, {
  componentPrefix: "v", // Optional: You can change the component prefix
});

app.mount("#app");
